import {Component, Input, OnInit} from '@angular/core';
import {OrderStatus, SubscriptionStatus} from "../../../../core/helpers/constants";
import {BenefitHistoryType} from "../../../../core/helpers/enums";

@Component({
  selector: 'app-benefit-history-status',
  templateUrl: './benefit-history-status.component.html',
  styleUrls: ['./benefit-history-status.component.scss']
})
export class BenefitHistoryStatusComponent implements OnInit {

  @Input() benefitHistoryType: BenefitHistoryType;
  @Input() orderStatusLabel?: string;
  @Input() subscriptionStatusLabel?: string;
  @Input() isAutoOrderEnabled?: boolean;
  @Input() orderStatus?: OrderStatus;
  @Input() subscriptionStatus?: SubscriptionStatus;
  @Input() alignRight: boolean = false;
  isSubscription: boolean;
  isAutoOrder: boolean;

  constructor() {
  }

  ngOnInit(): void {
    this.isSubscription = this.benefitHistoryType === BenefitHistoryType.Subscription;
    this.isAutoOrder = this.benefitHistoryType === BenefitHistoryType.AutoOrder;
  }

  isSubscriptionStatus(...statuses: any[]): boolean {
    return statuses.includes(this.subscriptionStatus);
  }

  isOrderStatus(...statuses: any[]): boolean {
    return statuses.includes(this.orderStatus);
  }

  protected readonly OrderStatus = OrderStatus;
  protected readonly SubscriptionStatus = SubscriptionStatus;
}
